const convertToHZ = (hz) => {
    const s = ['Hz', 'kHz', 'MHz', 'GHz', 'THz', 'PHz'];
    const e = Math.floor(Math.log(hz) / Math.log(1000));
    return (hz / Math.pow(1000, e)) + "" + s[e];
};

export default convertToHZ;